import { createApp } from 'vue';
import App from './App.vue';
import { isIphonex } from "@/utils";
window._env = _env;
const app = createApp(App);
app.mount('#sub');
if (_env.command === 'production' && _env.onSandbox) {
  useScriptTag('https://cdn.jsdelivr.net/npm/vconsole', () => {
    new window.VConsole();
  });
}
const iphonex = isIphonex();
if (iphonex) {
  document.body.style.setProperty('--safe-top', '.4rem');
  document.body.style.setProperty('--safe-bottom', '.34rem');
}